import { BrowserRouter, Switch, Route } from "react-router-dom";
import Landing from "./landing";
import Dashboard from "./dashboard";
import Pjt from "./pjt";

import AutogateExportIn from "./autogate_export";
import AutogateExportOut from "./autogate_export/out";
import AutogateImportIn from "./autogate_import";
import AutogateImporOut from "./autogate_import/out";
import AutogateDistriIn from "./autogate_distribusi";
import AutogateDistriOut from "./autogate_distribusi/out";
import AutogateDistri from "./autogate_distribusi/distribusi";
import Notfound from "../notfound";

export default () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact>
          <Landing />
        </Route>
        <Route path="/workspace">
          <Dashboard />
        </Route>
        <Route path="/pjt">
          <Pjt />
        </Route>
        <Route path="/autogate/exportin">
          <AutogateExportIn />
        </Route>
        <Route path="/autogate/exportout">
          <AutogateExportOut />
        </Route>
        <Route path="/autogate/importin">
          <AutogateImportIn />
        </Route>
        <Route path="/autogate/importout">
          <AutogateImporOut />
        </Route>
        <Route path="/autogate/distribusiin">
          <AutogateDistriIn />
        </Route>
        <Route path="/autogate/distribusiout">
          <AutogateDistriOut />
        </Route>
        <Route path="/autogate/distribusi">
          <AutogateDistri />
        </Route>
        <Route path="/*">
          <Notfound />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
